import React from 'react';
import {Button, Stack} from '@mui/material';
import type {ImagePreviewAction} from './ImagePreviewModal';

export interface ImagePreviewActionToolbarProps {
  actions: ImagePreviewAction[];
  onSelect: (actionId: string) => void;
}

/**
 * Presentational row of action buttons shown under the image in
 * `ImagePreviewModal`'s plain-preview mode. Renders nothing (via parent)
 * when `actions` is empty.
 */
const ImagePreviewActionToolbar = (props: ImagePreviewActionToolbarProps) => {
  const {actions, onSelect} = props;

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      aria-label="Image preview actions"
      sx={{p: 1.5, bgcolor: 'rgba(0, 0, 0, 0.72)'}}
    >
      {actions.map((action) => (
        <Button
          key={action.id}
          color="inherit"
          startIcon={action.icon}
          onClick={() => onSelect(action.id)}
          sx={{color: 'common.white'}}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
  );
};

export default ImagePreviewActionToolbar;

